/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
// import DTOClaimViewModal from "./DTOClaimViewModal";
import ClaimViewModalPresenter from './ClaimViewModalPresenter';
import { useTranslation } from 'react-i18next';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  claimViewData?: any;
}

const ClaimViewModalController = ({
  isModalOpen,
  closeModal,
  claimViewData,
}: ModalInterface) => {
  const { t } = useTranslation();

  return (
    <>
      {/* <DTOClaimViewModal /> */}

      <ClaimViewModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        claimViewData={claimViewData}
        trans={t}
      />
    </>
  );
};

export default ClaimViewModalController;
